import b1Door from '../assets/images/v59/b1-door.jpg';
import b1FrontDoor from '../assets/images/v59/b1-frontdoor.jpg';
import b1House from '../assets/images/v59/b1-house.jpg';
import b1Kitchen from '../assets/images/v59/b1-kitchen.jpg';
import b1Noon from '../assets/images/v59/b1-noon.jpg';
import b1Porch from '../assets/images/v59/b1-porch.jpg';
import b1Tv from '../assets/images/v59/b1-tv.jpg';
import b2Bleach from '../assets/images/v59/b2-bleach.jpg';
import b2Full from '../assets/images/v59/b2-full.jpg';
import b2Hall from '../assets/images/v59/b2-hall.jpg';
import b2Lib from '../assets/images/v59/b2-lib.jpg';
import b2Locker from '../assets/images/v59/b2-locker.jpg';
import b2Tray from '../assets/images/v59/b2-tray.jpg';
import b3Board from '../assets/images/v59/b3-board.jpg';
import b3Car from '../assets/images/v59/b3-car.jpg';
import b3Phone from '../assets/images/v59/b3-phone.jpg';
import b3Player from '../assets/images/v59/b3-player.jpg';
import b3Tape from '../assets/images/v59/b3-tape.jpg';
import b3Them from '../assets/images/v59/b3-them.jpg';
import hero from '../assets/images/v59/hero.jpg';
import pause1 from '../assets/images/v59/pause-1.jpg';
import pause2 from '../assets/images/v59/pause-2.jpg';
import pause3 from '../assets/images/v59/pause-3.jpg';
import sndHouse from '../assets/sounds/v59/snd-house.mp3';
import sndSchool from '../assets/sounds/v59/snd-school.mp3';
import sndSong from '../assets/sounds/v59/snd-song.mp3';

/* Keys are the prototype's image ids */
const MEMORY_MAP_IMAGES = {
    'B1-DOOR': b1Door,
    'B1-FRONTDOOR': b1FrontDoor,
    'B1-HOUSE': b1House,
    'B1-KITCHEN': b1Kitchen,
    'B1-NOON': b1Noon,
    'B1-PORCH': b1Porch,
    'B1-TV': b1Tv,
    'B2-BLEACH': b2Bleach,
    'B2-FULL': b2Full,
    'B2-HALL': b2Hall,
    'B2-LIB': b2Lib,
    'B2-LOCKER': b2Locker,
    'B2-TRAY': b2Tray,
    'B3-BOARD': b3Board,
    'B3-CAR': b3Car,
    'B3-PHONE': b3Phone,
    'B3-PLAYER': b3Player,
    'B3-TAPE': b3Tape,
    'B3-THEM': b3Them,
    HERO: hero,
    'PAUSE-1': pause1,
    'PAUSE-2': pause2,
    'PAUSE-3': pause3
};

const MEMORY_MAP_SOUNDS = {
    'SND-HOUSE': sndHouse,
    'SND-SCHOOL': sndSchool,
    'SND-SONG': sndSong
};

const CHAPTER_INTRO_IMAGES = ['B1-HOUSE', 'B2-HALL', 'B3-THEM'];
const CHAPTER_DONE_IMAGES = ['PAUSE-1', 'PAUSE-2', 'PAUSE-3'];

export {
    MEMORY_MAP_IMAGES,
    MEMORY_MAP_SOUNDS,
    CHAPTER_INTRO_IMAGES,
    CHAPTER_DONE_IMAGES
};
